import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import {
  Grid,
  Typography,
  Button,
  Paper,
  Box,
  Divider,
} from '@mui/material';
import { findOneTicket } from '../services/ticket.service';
import Barcode from 'react-barcode';

export default function TicketDet() {
  const location = useLocation();
  const history = useHistory();
  const otgIds = useMemo(() => location.state?.ids_otg || [], [location.state]);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const refs = useRef([]);

  useEffect(() => {
    const fetchAllTickets = async () => {
      try {
        const results = await Promise.all(
          otgIds.map((id) => findOneTicket(id).then((res) => res.data))
        );
        setTickets(results);
      } catch (err) {
        console.error('Error al cargar tickets:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllTickets();
  }, [otgIds]);

  const generarContenidoHTML = (html) => `
  <html>
    <head>
      <title>Ticket OTG</title>
      <style>
        @media print {
          * {
            box-sizing: border-box;
          }

          body {
            margin: 0;
            padding: 0;
            font-family: 'Courier New', monospace;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }

          .ticket {
  width: 320px;
  padding: 8px;
  text-align: center;
  page-break-after: always;
  font-size: 12px;
  line-height: 1.3;
  font-weight: bold; /* letra más gruesa */
  font-family: 'Courier New', monospace; /* conserva el estilo monoespaciado */
}

          h2, h6, p, div {
            margin: 2px 0;
            text-align: center;
          }

          /* centra las barras */
          .ticket svg,
          .ticket img {
            display: block;
            margin: 0 auto;
          }

          @page {
            size: auto;
            margin: 8mm;
          }
        }
      </style>
    </head>
    <body>
      <div class="ticket">${html}</div>
    </body>
  </html>
`;




  const imprimirHTMLenIframe = (html) => {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(generarContenidoHTML(html));
    doc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  };

  const imprimirTicket = (index) => {
    const contenido = refs.current[index]?.innerHTML;
    if (contenido) imprimirHTMLenIframe(`<div class="ticket">${contenido}</div>`);
  };

  const imprimirTodos = () => {
    const contenidoCompleto = refs.current.map(ref =>
      `<div class="ticket">${ref?.innerHTML}</div>`
    ).join('');
    imprimirHTMLenIframe(contenidoCompleto);
  };

  if (loading) return <Typography variant="body1">Cargando tickets...</Typography>;

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Tickets Generados: {tickets.length}
      </Typography>
      

      <Grid container spacing={4}>
        {tickets.map((ticket, index) => (
          <Grid item xs={12} md={6} key={ticket.id_otg}>
            <Paper
              elevation={3}
              sx={{
                p: 1,
                border: '1px dashed black',
                fontFamily: 'Gotham-Medium',
                fontSize: '15px',
                lineHeight: 1.3,
                textAlign: 'left',
              }}
              ref={(el) => (refs.current[index] = el)}
              className="ticket"
            >
              <Typography variant="body2" align="center" sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                OTG PRODUCTO DETERIORADO
              </Typography>

              <Typography variant="body2" gutterBottom>
                Ticket {index + 1} de {tickets.length}
              </Typography>

              <Box display="flex" justifyContent="center">
                <Barcode value={ticket.id_otg.toString()} />
              </Box>

              <Typography variant="body2"><strong>Producto:</strong> {ticket.Variacion.nombre_producto}</Typography>
              <Typography variant="body2">
                <strong>Cliente:</strong>{' '}
                {`${ticket.Cliente.primer_nombre} ${ticket.Cliente.segundo_nombre || ''} ${ticket.Cliente.ap_paterno} ${ticket.Cliente.ap_materno}`}
              </Typography>
              <Typography variant="body2"><strong>Origen:</strong> {ticket.ubiOrigen.nombre_ubicacion}</Typography>
              <Typography variant="body2"><strong>Fecha:</strong> {new Date(ticket.createdAt).toLocaleDateString()}</Typography>

              {ticket.Servicios.map((s, i) => (
                <Box key={i} sx={{ borderTop: '1px dashed black', mt: 1 }}>
                  <Typography variant="body2"><strong>Falla {i + 1}:</strong> {s.Falla.nombre_falla}</Typography>
                  <Typography variant="body2"><strong>Registrado como:</strong> {s.tipo_servicio}</Typography>
                </Box>
              ))}

              <Typography
                align="center"
                sx={{
                  fontFamily: 'Gotham-Medium',
                  textTransform: 'capitalize',
                  marginTop: '1rem',
                  borderTop: '1px solid black',
                  fontSize: '10px',
                }}
              >
                Recibí el producto Conforme
              </Typography>
              
            </Paper>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
              <Button
                variant="contained"
                onClick={() => imprimirTicket(index)}
                sx={{
                  backgroundColor: '#000',
                  color: '#fff',
                  '&:hover': { backgroundColor: '#333' },
                }}
              >
                Imprimir
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
